import Vue from "vue";
import Loading from "./loading";
export default {
  install(Vue) {
    Vue.directive("myLoading", Loading);
  },
};



// WEBPACK FOOTER //
// ./src/directiveLoading/index.js